import { useReduxState } from 'hooks';
import { breakpoints } from 'styles';
import {
  EmailMessageEditor,
  FormGroup,
  RadioGroup,
  Text
} from 'components/common/form';
import { ModalButtonWithForm } from 'components/common';

import type { EmailTemplateData } from 'shared-types';

interface Props {
  emailTemplates: EmailTemplateData[];
  emailTemplatesDefault: EmailTemplateData;
  onSubmit: (values: any) => Promise<boolean>;
  selectedRecipientsType: string;
  setSelectedRecipientsType: React.Dispatch<string>;
}

const CalendarEventDeleteSendInfo = ({
  emailTemplates,
  emailTemplatesDefault,
  onSubmit,
  selectedRecipientsType,
  setSelectedRecipientsType
}: Props) => {
  const {
    language,
    messages,
    serverConfig: { requireReasonWhenDeletingData }
  } = useReduxState();

  const handleRecipientsTypeChange = (value: string) => {
    setSelectedRecipientsType(value);
  };

  const handleSubmit = async (values) => {
    return await onSubmit(values);
  };

  const initialValues = emailTemplatesDefault
    ? {
        email: {
          ...emailTemplatesDefault.email,
          selectedTemplateIdentifier: emailTemplatesDefault.identifier
        },
        recipientsType: selectedRecipientsType
      }
    : {};

  return (
    <ModalButtonWithForm
      buttonCategory="danger"
      buttonIcon="trash-alt"
      buttonText={messages.commonDelete}
      buttonTextHideBreakpoint={breakpoints.small - 1}
      formAllowEmptyStrings={true}
      initialValues={initialValues}
      modalActionText={messages.eventCalendarDeleteEvent}
      modalTitle={messages.eventCalendarDeleteEvent}
      modalWidth={selectedRecipientsType === 'all' ? 'wide' : undefined}
      onSubmit={handleSubmit}
    >
      {() => (
        <div>
          <div>{messages.eventCalendarDeleteEventMessage}</div>

          <FormGroup
            label={messages.calendarEventEmailDeleteSendEmailToParticipants}
            style={{ marginTop: 25 }}
          >
            <RadioGroup
              field="recipientsType"
              options={[
                {
                  id: 'email-recipients-none',
                  label: messages.calendarEventEmailSettingsChangedDoNotSend,
                  value: 'none'
                },
                {
                  id: 'email-recipients-all',
                  label: messages.calendarEventEmailSettingsChangedSendToAll,
                  value: 'all'
                }
              ]}
              onChange={handleRecipientsTypeChange}
            />
          </FormGroup>

          {selectedRecipientsType === 'all' && (
            <EmailMessageEditor
              availableTemplates={emailTemplates}
              id="calendar-event-canceled"
              style={{ marginTop: 20 }}
            />
          )}

          {requireReasonWhenDeletingData ? (
            <FormGroup
              label={messages.commonDeletionReason}
              htmlFor="deletionReasonCalendarEvent"
              style={{ marginTop: 25 }}
            >
              <Text
                field="deletionReason"
                id="deletionReasonCalendarEvent"
                maxLength={255}
                autocomplete="off"
                placeholder={messages.commonInputDeletionReason}
                required={true}
              />
            </FormGroup>
          ) : null}
        </div>
      )}
    </ModalButtonWithForm>
  );
};

export default CalendarEventDeleteSendInfo;
